var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10 -6 38 38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 6.6h3.8v12.6H1.1zM3 5.1c-1.2 0-2-.9-2-2s.8-2 2-2 2 .8 2 2c.1 1.1-.7 2-2 2zM19 19.2h-3.8v-7c0-1.6-.6-2.7-1.9-2.7-1.1 0-1.7.7-2 1.5-.1.3-.1.6-.1 1v7.2H7.3v-8.5c0-1.6-.1-2.9-.1-4h3.3l.2 1.7h.1c.5-.8 1.7-2 3.8-2 2.5 0 4.4 1.7 4.4 5.4v7.4z"
  }))));
}
export default SvgLinkedin;